
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
// Components
import Snackbar from "@/components/Snackbar.vue";
// Entities
import { Warehouse, Company, WarehouseToCompany } from "@/entities/index";

@Component({
  components: {
    Snackbar,
  },
})
export default class AddWarehouseToCompany extends Vue {
  warehouseToCompany: WarehouseToCompany[] = [];
  warehouses: Warehouse[] = [];
  companies: Company[] = [];

  dialog = false;

  selectedWarehouse = "";
  selectedCompany = "";

  // ========== CRUD ========== //

  createWarehouseToCompany(): void {
    axios.post(`/api/warehouses-to-companies`, {
      warehouseId: this.selectedWarehouse,
      companyId: this.selectedCompany,
    });
    this.dialog = false;
    this.afterCreate();
  }

  async allCompanies(): Promise<void> {
    this.companies = (await axios.get(`/api/companies`)).data as Company[];
  }

  async allWarehouses(): Promise<void> {
    this.warehouses = (await axios.get(`/api/warehouses`)).data as Warehouse[];
  }

  mounted(): void {
    this.allCompanies();
    this.allWarehouses();
  }

  // ========== OTHER METHODS ========== //

  clear() {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.selectedWarehouse = "";
    this.selectedCompany = "";
  }

  showSnackbar() {
    const snackbar = this.$refs.snackbarAddWarehouseToCompany as any;
    snackbar.show();
  }

  afterCreate() {
    this.clear();
    this.showSnackbar();
    this.$emit("woc-assigned", this.warehouseToCompany);
  }
}
